import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { Spinner } from "react-bootstrap";

import * as actionCreater from "../../../../store/actions/orderActions";

import BasicHeaderSection from "../../sections/BasicHeaderSection";
import FormSection from "../../sections/FormSection";
import ErrorMessage from "../../ErrorMessage";
import TitleSectionFederal from "../../V2-federal/sections/TitleSection";
import FormSectionFederal from "../../V2-federal/sections/FormSection";
import ErrorMessageFederal from "../../V2-federal/ErrorMessage";
import TitleSectionReflection1 from "../../V2-reflection-1/sections/TitleSection";
import FormSectionReflection1 from "../../V2-reflection-1/sections/FormSection";
import ErrorMessageReflection1 from "../../V2-reflection-1/ErrorMessage";
import TitleSectionReflection2 from "../../V2-reflection-2/sections/TitleSection";
import FormSectionReflection2 from "../../V2-reflection-2/sections/FormSection";
import ErrorMessageReflection2 from "../../V2-reflection-2/ErrorMessage";
import TitleSectionReflection3 from "../../V2-reflection-3/sections/TitleSection";
import FormSectionReflection3 from "../../V2-reflection-3/sections/FormSection";
import ErrorMessageReflection3 from "../../V2-reflection-3/ErrorMessage";
import TitleSectionReflection4 from "../../V2-reflection-4/sections/TitleSection";
import FormSectionReflection4 from "../../V2-reflection-4/sections/FormSection";
import ErrorMessageReflection4 from "../../V2-reflection-4/ErrorMessage";

const StyledOrderStatusPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: calc(100vh - 100px);

  > div:nth-child(2) {
    flex-grow: 1;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    min-height: calc(100vh - 80px);
  }
`;

function OrderStatusPage() {
  const dispatch = useDispatch();
  const router = useRouter();
  const order = useSelector(state => state.order.order);
  const loading = useSelector(state => state.order.loading);
  const error = useSelector(state => state.order.error);

  const [state, setState] = useState({
    orderNumber: null,
    validated: false,
  });

  const handleChange =(e) => {
    const { id, name, value } = e.target || {};
    setState(prevState => ({ ...prevState, [name || id]: value }));
  };

  const handleSubmit = useCallback((e) => {
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      const section = document.querySelector(".form-control:invalid");
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      e.preventDefault();
      dispatch(actionCreater.checkOrder(state.orderNumber, router));
    }

    setState(prevState => ({ ...prevState, validated: true }));
  }, [dispatch, state, router]);

  useEffect(() => {
    dispatch(actionCreater.clearOrder());
  }, [dispatch]);

  useEffect(() => {
    if (router.query && router.query?.orderNumber) {
      setState(prevState => ({ ...prevState, orderNumber: router.query.orderNumber }));
      dispatch(actionCreater.checkOrder(router.query.orderNumber, router));
    }
  }, [dispatch, router]);

  if (loading) {
    return (
      <StyledOrderStatusPage>
        <Spinner animation="border" variant="secondary" />
      </StyledOrderStatusPage>
    );
  }

  if (error?.message) {
    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein") {
      return (
        <StyledOrderStatusPage>
          <ErrorMessageFederal message={error?.message} />
        </StyledOrderStatusPage>
      );
    }

    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
      return (
        <StyledOrderStatusPage>
          <ErrorMessageReflection1 message={error?.message} />
        </StyledOrderStatusPage>
      );
    }

    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
      return (
        <StyledOrderStatusPage>
          <ErrorMessageReflection2 message={error?.message} />
        </StyledOrderStatusPage>
      );
    }

    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
      return (
        <StyledOrderStatusPage>
          <ErrorMessageReflection3 message={error?.message} />
        </StyledOrderStatusPage>
      );
    }

    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
      return (
        <StyledOrderStatusPage>
          <ErrorMessageReflection4 message={error?.message} />
        </StyledOrderStatusPage>
      );
    }
    return (
      <StyledOrderStatusPage>
        <ErrorMessage message={error?.message} />
      </StyledOrderStatusPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein") {
    return (
      <StyledOrderStatusPage>
        <TitleSectionFederal
          title="Order Status"
        />
        <FormSectionFederal
          path={router.pathname}
          order={order}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledOrderStatusPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
    return (
      <StyledOrderStatusPage>
        <TitleSectionReflection1
          title="Order Status"
        />
        <FormSectionReflection1
          path={router.pathname}
          order={order}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledOrderStatusPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
    return (
      <StyledOrderStatusPage>
        <TitleSectionReflection2
          title="Order Status"
        />
        <FormSectionReflection2
          path={router.pathname}
          order={order}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledOrderStatusPage>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
    return (
      <StyledOrderStatusPage>
        <TitleSectionReflection3
          title="Check Order Status"
        />
        <FormSectionReflection3
          path={router.pathname}
          order={order}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledOrderStatusPage>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
    return (
      <StyledOrderStatusPage>
        <TitleSectionReflection4
          title="Order Status"
        />
        <FormSectionReflection4
          path={router.pathname}
          order={order}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledOrderStatusPage>
    );
  }
  return (
    <StyledOrderStatusPage>
      <BasicHeaderSection
        title="Order Status"
      />
      <FormSection
        path={router.pathname}
        order={order}
        values={state}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    </StyledOrderStatusPage>
  );
}

export default OrderStatusPage;
